// Kind → icon map for the move-with-automation modal. Local copy of the
// interview-plan automation drawer's KIND_ICONS so this shared component
// doesn't reach into `src/pages/...` and trip the layering rule.
//
// Keep in sync with:
//   src/pages/ats-job-creation/tabs/interview-plan/stage/automation/activityIcons.ts
// When the icon system gets a proper home in a shared layer, both
// should consume the same source.
import type { ElementType } from 'react';
import {
  Calendar,
  ClipboardCheck,
  Eye,
  File02,
  Mail01,
  MailInternal,
} from '@kula-ai/icons-core';
import { DocusignWordmarkAsset } from '@kula-ai/assets';
import { SurveyV2 } from '@/assets/icons/interview-plan';
import {
  Hackerrank,
  Hackerearth,
  CriteriaCorp,
  CodeInterview,
  Hireflix,
} from '@/assets/icons/ats';

const KIND_ICONS: Record<string, ElementType> = {
  interview: Calendar,
  email: Mail01,
  internal_email: MailInternal,
  review: Eye,
  assessment: ClipboardCheck,
  survey: SurveyV2,
  hackerrank: Hackerrank,
  hackerrank_interview: Hackerrank,
  hackerearth_assessment: Hackerearth,
  criteriacorp_assessment: CriteriaCorp,
  codeinterview_assessment: CodeInterview,
  hireflix_assessment: Hireflix,
  // The wordmark, not `DocusignAsset`: that one frames the mark in a tile and
  // draws it at roughly half the box, small beside every sibling glyph.
  esign: DocusignWordmarkAsset,
};

export const getActivityKindIcon = (kind: string | undefined): ElementType =>
  (kind && KIND_ICONS[kind]) || File02;
